import { Components } from '@mui/material'

import Fonts from '#/styles/Fonts'
import Palette from '#/styles/Palette'

export function OverridedIconButton(): Components {
  return {
    MuiIconButton: {
      styleOverrides: {
        colorError: {
          '&:not(.Mui-disabled)': {
            backgroundColor: Palette.red.light[100] + ' !important',
          },
        },
        colorSuccess: {
          '&:not(.Mui-disabled)': {
            backgroundColor: Palette.green.mint[100] + ' !important',
          },
        },
        colorWarning: {
          '&:not(.Mui-disabled)': {
            backgroundColor: Palette.orange.self[100] + ' !important',
          },
        },
        root: {
          fontSize: Fonts.fontSize.XXL,
        },
      },
    },
  }
}
